module.exports = __webpack_public_path__ + "static/media/lovedCustomersPrimary.2e0141c9.svg";